import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({

  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
  
})
export class AlertComponent implements OnInit {

  constructor(
     private dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {

     }

  ngOnInit() {
    
    {
      
    }
  }
  onNoClick(){
   this.dialogRef.close(0); 
  }
  yes(){
    this.dialogRef.close(1); 
  }

}
